import type { FilterPill } from '@/app/common/filters/surfaces/bar/pills/types.ts';
import type { BarPillContext } from '@/app/common/filters/surfaces/bar/resultsPills/barPills.ts';
import { assembleBarPills } from '@/app/common/filters/surfaces/bar/resultsPills/barPills.ts';

export { getFilterPillFromGroupsByNames } from '@/app/common/filters/surfaces/bar/resultsPills/barPills.ts';

export const createBarPills = (context: BarPillContext): FilterPill[] => assembleBarPills(context, 'desktop');

export const createMobileBarPills = (context: BarPillContext): FilterPill[] => assembleBarPills(context, 'mobile');
